// @ts-expect-error - CJS-only package with no types for the /dist path
import * as mod from "vue-resizable/dist/vue-resizable.common.js";

type ModShape = { default?: { default?: unknown } | unknown };
const ns = mod as ModShape;
const component =
  (ns.default as { default?: unknown } | undefined)?.default ??
  ns.default ??
  mod;

export default component;
